import React from 'react';
export function SiteFooter() {
  return <footer className="sticky bottom-0 z-30 mt-auto border-t border-line bg-ink/95 px-5 py-2.5 text-center backdrop-blur sm:px-8" data-id="element-305" data-mp="1dqrohw3lfk7t">
      <p className="text-[11px] text-muted" data-id="element-306" data-mp="3mhj8dwehosm9">
        Developed by{' '}
        <span className="font-semibold tracking-[0.12em] text-body" data-id="element-307" data-mp="3mfpxu60r9o8z">
          LIKHAPAY I.T SOLUTIONS
        </span>
      </p>
    </footer>;
}